import React from "react";
import Grid from "@mui/material/Grid2";
import IFLogo from "../../assets/images/company-logo/IFLogo.png";
import Helevtic from "../../assets/images/company-logo/Helvetic.png";
import PerIF from "../../assets/images/customer_review/per_IF.png";
import HelveticReview from "../../assets/images/customer_review/helvetic.png";
import { Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "ClientReview";

const classes = {
  mainContainer: `${PREFIX}-mainContainer`,
  row: `${PREFIX}-row`,
  customerImage: `${PREFIX}-customerImage`,
  customerLogo: `${PREFIX}-customerLogo`,
  customerName: `${PREFIX}-customerName`,
  customerDesig: `${PREFIX}-customerDesig`,
  reviewData: `${PREFIX}-reviewData`,
  customerData: `${PREFIX}-customerData`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.mainContainer}`]: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: theme.spacing(2),
    marginBottom: "4%",
  },
  [`& .${classes.row}`]: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  [`& .${classes.customerImage}`]: {
    width: "100%",
    maxWidth: 300,
    height: "auto",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      transform: "scale(0.7)",
    },
  },
  [`& .${classes.customerLogo}`]: {
    [theme.breakpoints.down("sm")]: {
      transform: "scale(0.7)",
      padding: 0,
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(2),
      padding: 0,
    },
  },
  [`& .${classes.customerName}`]: {
    fontSize: 24,
    fontWeight: 500,
    color: "#808080",
    fontFamily: "AvenirLTStd-Roman",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      fontSize: 20,
      paddingLeft: "1rem",
    },
  },
  [`& .${classes.customerDesig}`]: {
    fontSize: 20,
    fontWeight: 500,
    color: "#808080",
    marginBottom: "20px",
    fontFamily: "AvenirLTStd-Roman",
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
      paddingLeft: "1rem",
      textAlign: "left",
    },
  },
  [`& .${classes.reviewData}`]: {
    fontSize: 20,
    fontWeight: 100,
    textAlign: "left",
    color: "#223140",
    fontFamily: "AvenirLTStd-Roman",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
      textAlign: "left",
      padding: "1rem",
    },
  },
  [`& .${classes.customerData}`]: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    fontFamily: "AvenirLTStd-Roman",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      textAlign: "left",
    },
  },
  [`& .${classes.row} > .${classes.customerLogo}`]: {
    [theme.breakpoints.down("md")]: {
      order: 1,
      height: "150px",
    },
  },
  [`${classes.customerImage}`]: {
    [theme.breakpoints.down("md")]: {
      width: "150px",
    },
  },
}));

function ClientReview() {
  return (
    <StyledGrid container className={classes.mainContainer}>
      <Grid container className={classes.row}>
        <Grid size={{ xs: 12, md: 7 }} className={classes.customerData}>
          <img className={classes.customerImage} src={PerIF} alt="Person IF" />
          <Box>
            <Typography className={classes.customerName}>
              Per Magnusson
            </Typography>
            <Typography className={classes.customerDesig}>
              Chief Technical Officer
            </Typography>
            <Typography className={classes.reviewData} variant="body2">
              There are now no paper slips or images required as everything is
              online. Digital log sheets have significantly reduced our team's
              workload and same-day invoicing can be achieved by the finance
              team.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }} className={classes.customerLogo}>
          <img src={IFLogo} className={classes.customerLogo} alt="IF Logo" />
        </Grid>
      </Grid>

      <Grid container className={classes.row}>
        <Grid size={{ xs: 12, md: 3 }} className={classes.customerLogo}>
          <img
            src={Helevtic}
            className={classes.customerLogo}
            alt="Helevtic Logo"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 7 }} className={classes.customerData}>
          <img
            className={classes.customerImage}
            src={HelveticReview}
            alt="Helvetic Person"
          />
          <Box>
            <Typography className={classes.customerName}>
              Christian Suhner
            </Typography>
            <Typography className={classes.customerDesig}>
              Chief Technical Officer
            </Typography>
            <Typography className={classes.reviewData} variant="body2">
              The REDiFly software adapts to our organisation rather than us
              having to adapt the organisation around the software.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </StyledGrid>
  );
}

export default ClientReview;
